export default {
  AUTH_DATA_DASHBOARD: 'Dashboard',
  AUTH_USER_ADM: 'System',
  AUTH_SYS_APP_CONFIG: 'Setting',
  AUTH_CUSTOMER_SERVICE_ADM: 'Customer Service',
  AUTH_MERCHANT_MANAGER: 'Merchant Auth',
  AUTH_SETTLEMENT_MANAGER: 'Payin/Payout',
  AUTH_SETTLEMENT_BALANCE: 'Balance',
  AUTH_SETTLEMENT_RECHARGE: 'Top Up',
  AUTH_SETTLEMENT_WITHDRAW: 'Cash Out',
  AUTH_SETTLEMENT_STATISTICS_FILE_DOWN: 'Summary',
  AUTH_PAYMENT_LINK: 'Payment Links',
  AUTH_DISBURSEMENT_APPROVE: 'Payout Approve',
  AUTH_DISBURSEMENT_PAGE: 'Small-value Payment',
  AUTH_DISBURSEMENT_CHECK: 'Payout Review',
  AUTH_DISBURSEMENT_CONFIRM: 'Payout Create',
  AUTH_PAYMENT_PAGE: 'Payment Page',
  AUTH_SETTLEMENT_BALANCE_DETAIL: 'Balance Detail',
  AUTH_SETTLEMENT_TRANSFER: 'Transfer Record',
  AUTH_TRANSACTION_PAYIN: 'Payin',
  AUTH_TRANSACTION_PAYOUT: 'Payout',
  AUTH_TRANSACTION_SUMMARY: 'Transaction Summary',
  AUTH_CUSTOMER_SERVICE_PAYIN: 'Payin Search',
  AUTH_CUSTOMER_SERVICE_PAYOUT: 'Payout Search',
  AUTH_CUSTOMER_SERVICE_TICKET: 'Tickets',
  AUTH_ROLE_ADM: 'Role Management',
  AUTH_MERCHANT_STORE_CREATE: 'Create Store QR Code',
  AUTH_MERCHANT_STORE_DOWNLOAD: 'Download Store QR Code',
  AUTH_VA_COLLECTION_ADM: 'VA Collection',
  AUTH_LARGE_AMOUNT_KEY: 'Send Payments',
  AUTH_FINANCIALS_SETTING: 'Financial Settings',
  QRCODE_KEY: 'QR Stand',
  AUTH_QRCODE_ADM: 'QR Stand List',
  AUTH_LARGE_AMOUNT: 'Large-value Payment',
  AUTH_LARGE_CREATE_DISBURSEMENT: 'Large-value Beneficiary',
  DASHBOARD_KEY: 'Dashboard',
  FINANCIAL_KEY: 'Financials',
  TRANSACTION_KEY: 'Transactions',
  CUSTSER_KEY: 'Customer Service',
  PAYMENT_LINK_KEY: 'Payment links',
  SEND_PAYMENT_KEY: 'Send Payments',
  PAYMENT_PAGE_KEY: 'Payment Page',
  DEVELOPER_KEY: 'Developer',
  SYS_KEY: 'System',
  MCH_STORE_KEY: 'MerChant Store',
  VA_COLLECTION_KEY: 'VA Collection',
  AUTH_TRANSACTION_REFUND: 'Refund Transaction',
  AUTH_PAYMENT_REFUND: 'Refund Transaction Button',
  AUTH_CUSTOMER_SERVICE_REFUND: 'Refund Transaction Query',
  SPLIT_KEY: 'Platform',
  AUTH_SPLIT_PAYMENT: 'Split Transaction',
  AUTH_SPLIT_MERCHANT: 'Accounts'
}
